export default "__VITE_ASSET__CAKBQknc__"